import { Component, Vue, Mixins } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { LoginStatus } from '@/generated/api';
import { Action } from 'vuex-class';
import env from '@env'
import formatDateTime from 'date-fns-tz/esm/format';
import parseDateTime from 'date-fns/parseISO';
import { addMinutes } from 'date-fns';
import BASEAPI from '@/util/BASEAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import BASEComponentVue from '@/components/BASEComponentVue';


@Component
export default class CommonView extends Mixins(BASEComponentVue) {
    public env = env;

    @State('user')
    public loginStatus!: LoginStatus | null;

    public async isLoginRedirect(securitySafe: boolean): Promise<boolean> {
        if (!this.loginStatus) {
            // もしログインされてなければ再確認
            await this.getUserAPI();
        }

        // editinfo==true のとき、中間ログインだと再ログイン
        if (!this.loginStatus) {
            this.$router.replace("/login?url=" + this.$route.path);
            return true;
        }

        // if (securitySafe) {
        //     this.$router.replace("/login?url=" + this.$route.path);
        //     return true;
        // }
        return false;
    }

    public async changeLanguage(): Promise<void> {
        await this.changeLanguageAPI();
    }

    @Action('getUserAPI')
    public getUserAPI!: () => Promise<void>;

    @Action('changeLanguageAPI')
    public changeLanguageAPI!: () => Promise<void>;

    public comma(value: number): string {
        return new Intl.NumberFormat('ja-JP', { style: 'decimal' }).format(value);
    }

    public dateParse(value: string | Date): Date {
        if (value instanceof Date) {
            return value;
        } else if (typeof value === "string") {
            return parseDateTime(value);
        } else {
            return parseDateTime("" + value);
        }
    }

    public dateFormat(value: string | Date): string {
        let dateString = formatDateTime(this.dateParse(value), "yyyy年MM月dd日p", { timeZone: 'Asia/Tokyo' });
        return dateString;
    }

    public dateFormat2(value: string | Date): string {
        let dateString = formatDateTime(this.dateParse(value), "yyyy年MM月dd日 hh:mm", { timeZone: 'Asia/Tokyo' });
        return dateString;
    }

    public dateFormat3(value: string | Date): string {
        let dateString = formatDateTime(this.dateParse(value), "yyyy年MM月dd日", { timeZone: 'Asia/Tokyo' });
        return dateString;
    }

    public dateFormatSimple(value: string | Date): string {
        let dateString = formatDateTime(this.dateParse(value), "yyyy/MM/dd", { timeZone: 'Asia/Tokyo' });
        return dateString;
    }

    public dateFormatToSting(value: string | Date): string {
        let dateString = formatDateTime(this.dateParse(value), "yyyy-MM-dd", { timeZone: 'Asia/Tokyo' });
        return dateString;
    }

    public dateAddMinutes(value: string | Date, minutes: number): Date {
        return addMinutes(this.dateParse(value), minutes);
    }
}
